import { type Permissions } from 'services/constants';
import { useAppSelector } from 'store';

export const usePermissionCheck = (
    permissionToCheck: (typeof Permissions)[keyof typeof Permissions],
) => {
    const { permissions } = useAppSelector((state) => state.auth);
    return permissions.includes(permissionToCheck);
};
